<template>
    <div>
        <Snackbar v-if="errored" msg="Error from Server" />
        <Snackbar v-if="edited" msg="Operation Successfull" />
        <v-card-title>Edit Activity</v-card-title>
        <v-col cols="12">
        <v-form ref="form" v-model="valid">
            <v-container>
            <v-row>
                <v-col
                cols="9"
                >
                    <v-text-field
                        v-model="title"
                        :rules="titleRules"
                        :loading="loading"
                        label="Title*"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                cols="3"
                >
                    <v-checkbox
                    v-model="personalActivity"
                    label="Is a personal activity?"
                    ></v-checkbox>
                </v-col>                
                <v-col cols="6">
                    <v-select
                    :items="projects"
                    :loading="loading"
                    :disabled="loading"
                    item-text="name"
                    label="Select a project"
                    dense
                    return-object
                    multiple
                    chips
                    v-model="project"
                    ></v-select>

                </v-col>
                <v-col
                cols="6"
                >
                    <v-file-input
                        :rules="imageRules"
                        v-model="image"
                        show-size
                        accept="image/*"
                        label="File input"
                        clearable
                    ></v-file-input>
                </v-col>
                <v-col cols="4">
                    <v-select
                    :rules="categoryRules"
                    :items="categories"
                    :loading="loading"
                    :disabled="loading"
                    item-text="name"
                    label="Select a category*"
                    dense
                    return-object
                    multiple
                    chips
                    v-model="category"
                    ></v-select>

                </v-col>
                <v-col
                cols="4"
                >
                <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="date"
                    scrollable
                    :first-day-of-week="1"
                    locale="es-ES"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(date)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-dialog>
                </v-col>
                <v-col cols="4">
                <v-text-field
                    v-model="link"
                    :rules="linkRules"
                    :loading="loading"
                    label="Link"
                ></v-text-field>

                </v-col>
                <v-col
                cols="12"
                >
                    <VueEditor v-model="description" :loading="loading" :rules="descriptionRules"></VueEditor>
                </v-col>
                <v-col>
                    <v-btn
                        depressed
                        :disabled="loading"
                        :loading="loading"
                        color="primary"
                        class="mr-4"
                        @click="submit"
                        >
                        Submit
                    </v-btn>
                </v-col>
            </v-row>
            </v-container>
        </v-form>
        </v-col>
    </div>
</template>
<script>
import axios from '../../plugins/axios'
import { VueEditor } from "vue2-editor"
import Snackbar from '@/components/Snackbar.vue'
export default {
    name: 'EditActivity',
    components: {
        Snackbar,
        VueEditor
    },
	props: ['editId'],
    data: () => ({
        projects: [],
        activity: null,
        valid: false,
        loading: false,
        errored: false,
        edited: false,
        modal: false,
        image: null,
        title: '',
        description: '',
        category: [],
        link: '',
        date: null,
        personalActivity: false,
        project: [],
        categories: [],
        titleRules: [
            v => !!v || 'Title is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        descriptionRules: [
            v => !!v || 'Description is required'
        ],
        categoryRules: [
            v => v.length > 0 || 'Must have one category'
        ],
        imageRules: [
            value => !value || value.size < 500000 || 'Image size should be less than 500 KB!',
        ],
        linkRules: [
            v => (!v || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(v)) || 'Must be a valid link'
        ],
    }),
    mounted() {
        this.getActivity();
    },
    
    methods: {
        getActivity(){
            this.loading = true
            axios
            .get(`/activity/byId/` + this.editId)
            .then(res => {
                this.activity = res.data.data
                this.loading = false
                this.title = this.activity.title;
                this.link = this.activity.link;
                this.description = this.activity.description;
                this.project = this.activity.projectId;
                this.date = this.activity.date.substr(0, 10);
                this.category = this.activity.category;
                this.image = new File(this.activity.image.data, this.title, {type: 'image/*'});
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
                this.loading = false
            });
            axios
            .get('/project/')
            .then((res) => this.projects = res.data.data)
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
            });
            axios
            .get(`/category/?section=Activity`)
            .then(res => {
                this.categories = res.data.data
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
            })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const fr = new FileReader()
                fr.readAsDataURL(file);
                fr.onload = () => resolve(fr.result);
                fr.onerror = error => reject(error);
            })
        },
        async submit () {
            this.errored, this.edited = false
            if(this.$refs.form.validate()){
                this.loading = !this.loading;
                let {title, description, date, category,
                    activity, image, link, project} = this;
                let data = {
                    title, 
                    description,
                    link,
                    date,
                    projectId: project.map(p => p._id),
                    // toolId: tool? tool._id : null,
                    category: category.map(c => c._id)
                }
                if(image) {
                    let fileToBase64 = await this.toBase64(image)
                    data['image'] = fileToBase64
                }
                axios.put(`/activity/`,
                    {
                        condition: {_id: activity._id},
                        data
                    })
                    .then(res => {
                        this.activity = res.data.data;
                        this.edited = true
                    })
                    .catch(err => {
                        console.error("error", err)
                        this.errored = true
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },

		reset () {
			this.$refs.form.reset();
            this.description = null;
		}        
    },
    watch: {
        editId: function() {
			if(this.editId){
				this.getActivity();
			}
        }
    }        
}
</script>